export default __webpack_public_path__ + "static/media/Certified-Preowned.1e10e019.png";